export enum Platforms {
  IOS = 'ios',
  ANDROID = 'android',
  CORDOVA = 'cordova',
  DESKTOP = 'desktop',
}

export enum PermissionStatus {
  NOT_REQUESTED = 0,
  DENIED_ALWAYS = -1,
  GRANTED = 1,
}

export enum ModifierSelectionType {
  single = 'SINGLE',
  multiple = 'MULTIPLE'
}

export enum Month {
  january = 'January',
  february = 'February',
  march = 'March',
  april = 'April',
  may = 'May',
  june = 'June',
  july = 'July',
  august = 'August',
  september = 'September',
  october = 'October',
  november = 'November',
  december = 'December'
}
export const MONTH = [
  {month: Month.january, index: 1},
  {month: Month.february, index: 2},
  {month: Month.march, index: 3},
  {month: Month.april, index: 4},
  {month: Month.may, index: 5},
  {month: Month.june, index: 6},
  {month: Month.july, index: 7},
  {month: Month.august, index: 8},
  {month: Month.september, index: 9},
  {month: Month.october, index: 10},
  {month: Month.november, index: 11},
  {month: Month.december, index: 12},
];

export enum DiscountType {
  coupon = 'COUPON',
  discount = 'DISCOUNT'
}
